import { useState, useCallback } from 'react';
import { type DisplayUnit, DISPLAY_UNIT_KEY, getStoredDisplayUnit, formatLength } from '../lib/units';

/**
 * Hook for user-selectable display unit (mm / cm / m).
 * Persists choice in localStorage.
 */
export function useDisplayUnit() {
  const [displayUnit, setDisplayUnitState] = useState<DisplayUnit>(getStoredDisplayUnit);

  const setDisplayUnit = useCallback((unit: DisplayUnit) => {
    setDisplayUnitState(unit);
    try { localStorage.setItem(DISPLAY_UNIT_KEY, unit); } catch {}
  }, []);

  // Shorthand: format mm value using current user preference
  const fmt = useCallback((valueMm: number) => formatLength(valueMm, displayUnit), [displayUnit]);

  return { displayUnit, setDisplayUnit, fmt } as const;
}
